const features = {
  theShop: 'theShop',
  candleSubscription: 'candleSubscription',
  fragranceFamiliesPage: 'fragranceFamiliesPage',
  noteLibPages: 'noteLibPages',
  addQuebecToCanada: 'addQuebecToCanada',
  wallet: 'wallet',
  defaultCoupon50: 'defaultCoupon50', // PF-892
  hideCancelSubscriptionButton: 'hideCancelSubscriptionButton', // EP-1424
  jasonWuGwp: 'JasonWuGwp', // SB-2811
  scentPreferences: 'scentPreferences', // EP-1630
  theEdit: 'theEdit', // PF-1242
  candleClubMoreBanners: 'candleClubMoreBanners', // CRO-26
  partytown: 'partytown', // PF-1185
  techCartContinueBar: 'techCartContinueBar', // CRO-72
  collaborationSaks: 'collaborationSaks', // PF-1389
  fillYourQueueSweepstakes: 'fillYourQueueSweepstakes', // PF-1668
  optInPopups: 'optInPopups', // PF-1279
  freeShippingProgressBar: 'freeShippingProgressBar', // EP-1845
  magicLinkWeb: 'magicLinkWeb', // EP-1869
  cotyNYNJ: 'cotyNYNJ', // PF-1411
  strapiBanners: 'strapiBanners', // PF-1464
  giftHub: 'giftHub', // EP-1935
  giftHubNotification: 'giftHubNotification', // EP-1989
  holiday22SaleBadge15: 'holiday22SaleBadge15', // EP-1931
  holiday22SaleBadge20: 'holiday22SaleBadge20', // EP-1931
  holidayCatalogue: 'holidayCatalogue', // EP-1939
  holiday22Sub60: 'holiday22Sub60', // EP-1916
  holiday22CardUpdate60: 'holiday22CardUpdate60', // EP-1925
  holiday22Resubscribe60: 'holiday22Resubscribe60', // EP-1924
  giftSetProductPage: 'giftSetProductPage', // EP-2005
  blackFridayTopHomePageBanner: 'blackFridayTopHomePageBanner',
  cyberMondayTopHomePageBanner: 'cyberMondayTopHomePageBanner',
  gwpSpecificSku: 'gwpSpecificSku', // PF-1569
  gwpBuyYourQueue: 'gwpBuyYourQueue', // PF-1568
  gwpSpendThreshold: 'gwpSpendThreshold', // PF-1567
  gwpExcludeVials: 'gwpExcludeVials', // PF-1567
  giftSubscriptionOffer: 'giftSubscriptionOffer', // PF-1570
  holidayBannerUpdateV2: 'holidayBannerUpdateV2', // EP-2007
  seoStrapi: 'seoStrapi', // EP-1823
  cartEcommercePromos: 'cartEcommercePromos', // PF-1564
  cacheForBots: 'cacheForBots', // EP-1962
  addonsPhase1Candle: 'addonsPhase1Candle', // PF-1683
  addonsPhase1Case: 'addonsPhase1Case', // PF-1683
  // Website takeovers, `featuredBrand` prefix for brand page, `websiteTakeover` prefix for entry points
  strapiFeaturedBrand: 'strapiFeaturedBrand', // PF-1525
  strapiWebsiteTakeover: 'strapiWebsiteTakeover', // PF-1525
  attentiveCollectPhoneNumber: 'attentiveCollectPhoneNumber', // EP-2021
  scentbirdPodcastEntryPoints: 'scentbirdPodcastEntryPoints', // PF-1682
  scentHoroscope: 'scentHoroscope', // PF-1626
  postClickVWO: 'postClickVWO',
  faro: 'faro', // EP-2057
  newrelicWeb: 'newrelicWeb', // EP-2057
  shopSamples: 'shopSamples', // EP-2037
  strapiDynamicPage: 'strapiDynamicPage', // PF-1657
  mobileAppEntryPoint: 'mobileAppEntryPoint', // EP-2046
  ssrApiCache: 'ssrApiCache', // EP-2133
  saksGreyCase: 'greyCaseForSaksGwp', // PF-1706
  hideCasesReviews: 'hideCasesReviews', // EP-2145
  limitedDrops: 'limitedDrops', // PF-1695
  coarPhysicalRebrand: 'coarPhysicalRebrand', // PF-1751
  holidayMothersDay: 'holidayMothersDay', // PF-1768
  driftEcommerce: 'driftEcommerce', // PF-1715
  driftEcommercePromo: 'driftEcommercePromo', // PF-1770
  driftEcommercePromoModal: 'driftEcommercePromo', // PF-1770
  travelSizeFragrances: 'travelSizeFragrances', // EP-2099
  strapiMainPageBanners: 'strapiMainPageBanners', // PF-1865
  holidayFathersDay: 'holidayFathersDay', // PF-1850
  budgieChatAssistance: 'budgieChatAssistance', // PF-1868
  caseUpsellAddToCart: 'caseUpsellAddToCart', // EP-2285
  caseUpsellAddToQueue: 'caseUpsellAddToQueue', // EP-2286
  caseUpsellHeretic: 'caseUpsellHeretic', // EP-2287
  memorialSale: 'memorialSale', // EP-2300, EP-2308
  strapiPromoCard: 'strapiPromoCard', // PF-1697
  accessoriesEntryPoints: 'accessoriesEntryPoints', // EP-2319
  coarShopPage: 'coarShopPage', // EP-2296
  coarTarotGWP: 'coarTarotGWP', // EP-2331
  hideGoogleAuth: 'hideGoogleAuth', //EP-2342
  driftSubscription: 'driftSubscription', // PF-1759
  driftSubscriptionLaunchPromo: 'driftSubscriptionLaunchPromo', // PF-1759
  cheqAi: 'cheqAi',
  sri: 'sri', // CRO-254,
} as const


export type FeatureName = typeof features[keyof typeof features]

export default features
